/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * grimoire/v1/automation_phase.proto
 * OpenAPI spec version: version not set
 */

export type CreateAutomationTriggerStage =
  (typeof CreateAutomationTriggerStage)[keyof typeof CreateAutomationTriggerStage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateAutomationTriggerStage = {
  AUTOMATION_STAGE_UNSPECIFIED: 'AUTOMATION_STAGE_UNSPECIFIED',
  AUTOMATION_STAGE_DRAFT: 'AUTOMATION_STAGE_DRAFT',
  AUTOMATION_STAGE_PUBLISHED: 'AUTOMATION_STAGE_PUBLISHED',
} as const;
